import React, { useEffect, useState } from "react";
import { useAuth } from "../../../components/utils/oidc/AuthProvider";
// import LoadingSpinner from "../../../components/LoadingScreen";
import LoadingSpinner from "./LoadingSpinner";
import { forceLogout } from "../../../services/oidc/authConfig";

function CallbackPage({ history }) {
  const { handleCallback, isAuthenticated } = useAuth();
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const processCallback = async () => {
      try {
        await handleCallback();
        history.replace(sessionStorage.getItem("post_login_redirect") || "/");
      } catch (error) {
        console.error("❌ OAuth callback failed:", error);
        setError(error.message);
        setIsProcessing(false);
        forceLogout("callback_failed");
        setTimeout(() => {
          window.location.href = "/login?reason=callback_failed";
        }, 3000);
      }
    };
    processCallback();
  }, [handleCallback, history]);

  const containerStyle = {
    textAlign: "center",
    margin: "auto",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    padding: "30px",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  };

  const headingStyle = {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#111",
    marginBottom: "10px",
  };

  const textStyle = {
    color: "#555",
    marginBottom: "16px",
  };

  const buttonStyle = {
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  };

  const iconStyle = (color) => ({
    width: "64px",
    height: "64px",
    margin: "0 auto 16px",
    color,
  });

  // ✅ Success state
  if (isAuthenticated && !error) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={iconStyle("#16a34a")}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 style={headingStyle}>Login Successful!</h2>
          <p style={textStyle}>Redirecting to your dashboard...</p>
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  // ⏳ Processing state
  if (isProcessing && !error) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <LoadingSpinner />
          <h2 style={headingStyle}>Completing Sign In</h2>
          <p style={textStyle}>
            Please wait while we finish setting up your session...
          </p>
        </div>
      </div>
    );
  }

  // ❌ Error state
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle("#dc2626")}>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <h2 style={headingStyle}>Login Failed</h2>
        <p style={textStyle}>
          {error || "An unexpected error occurred during login."}
        </p>
        <p style={{ ...textStyle, fontSize: "14px" }}>
          Redirecting to login page in a few seconds...
        </p>
        <button
          style={buttonStyle}
          onClick={() => (window.location.href = "/login")}
        >
          Try Again
        </button>
      </div>
    </div>
  );
}

export default CallbackPage;
